/**
 * A chunky, filled heart SVG used across the gallery.
 * Extracted so that LikeButton (interactive) and the masonry/grid
 * (display-only) can share the exact same look.
 */
export function Heart({
  filled,
  size = 20,
  strokeWidth = 2,
}: {
  filled: boolean;
  size?: number;
  strokeWidth?: number;
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden
      style={{ display: 'block' }}
    >
      <path
        d="M12 21s-7.5-4.6-9.6-9.1C.9 8.4 2.4 4.5 5.7 3.2c1.9-.7 4-.2 5.4 1.3l.9 1 .9-1c1.4-1.5 3.5-2 5.4-1.3 3.3 1.3 4.8 5.2 3.3 8.7C19.5 16.4 12 21 12 21z"
        fill={filled ? 'var(--color-error)' : 'none'}
        stroke={filled ? 'var(--color-error)' : 'currentColor'}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
